module.exports = __webpack_public_path__ + "static/media/MHRP52N0003.cea91bcb.svg";